const SELECTORS = {
  generalWrapSortable: '.dbl-dashboard-filter-wrap-sortable',
  userFilter: '.dbl-dashboard-user-filter',
};

const getDeepestMatchedElement = (root: HTMLElement, selector: string): HTMLElement | null => {
  const candidates = Array.from(root.querySelectorAll(selector)) as HTMLElement[];
  if (candidates.length === 0) {
    return null;
  }
  return candidates[candidates.length - 1];
};

export const restoreTopFiltersChildrenDisplay = (root: HTMLElement): void => {
  const containers = [
    ...Array.from(root.querySelectorAll(SELECTORS.generalWrapSortable)),
    ...Array.from(root.querySelectorAll(SELECTORS.userFilter)),
  ] as HTMLElement[];

  containers.forEach((container) => {
    Array.from(container.children).forEach((child) => {
      (child as HTMLElement).style.removeProperty('display');
    });
  });
};

/**
 * 折叠态：按“一行能完整放下”的规则隐藏多余子元素（display:none）。
 * - 不能用 max-height/overflow:hidden 裁剪，否则错误提示等普通文案会被一起裁掉；
 * - 折叠态下容器样式会被强制 nowrap，避免窗口变窄时产生“先换行再隐藏”的闪动；
 * - 这里通过量测子元素右边界是否溢出容器来决定保留哪些子元素。
 */
export const applyTopFiltersCollapseToFirstRow = (root: HTMLDivElement): void => {
  const collapseToFirstRow = (selector: string): void => {
    const container = getDeepestMatchedElement(root, selector);
    if (!container) {
      return;
    }

    const children = Array.from(container.children) as HTMLElement[];
    if (children.length <= 1) {
      return;
    }

    const prevAlignItems = container.style.alignItems;
    container.style.alignItems = 'flex-start';

    try {
      /**
       * 关键：量测前必须让所有子元素都参与布局。
       * - 折叠态下我们会写入 `style.display='none'`；
       * - 如果直接对“当前可见项”量测，那么页面变宽/删除筛选器后，被隐藏项不会参与换行，
       *   也就无法“补位回到第一行”。
       */
      children.forEach((child) => {
        child.style.display = '';
      });

      const containerRect = container.getBoundingClientRect();
      const containerRight = Math.round(containerRect.right);

      let hasOverflow = false;
      children.forEach((child) => {
        if (hasOverflow) {
          child.style.display = 'none';
          return;
        }

        const rect = child.getBoundingClientRect();
        const childRight = Math.round(rect.right);
        const shouldShow = childRight <= containerRight;
        child.style.display = shouldShow ? '' : 'none';
        if (!shouldShow) {
          hasOverflow = true;
        }
      });
    } finally {
      if (prevAlignItems) {
        container.style.alignItems = prevAlignItems;
      } else {
        container.style.removeProperty('align-items');
      }
    }
  };

  collapseToFirstRow(SELECTORS.generalWrapSortable);
  collapseToFirstRow(SELECTORS.userFilter);
};

